module.exports = __webpack_public_path__ + "img/banner1.cac5c2f0.png";